import { AlertTriangle } from "lucide-react";

export default function CancellationPolicy({ className = "" }) {
  return (
    <div data-testid="cancellation-policy" className={`border border-white/10 bg-[#0C0C0E] p-6 ${className}`}>
      <div className="flex items-center gap-2 mb-4">
        <AlertTriangle size={15} className="text-[#C44536]" />
        <p className="text-xs uppercase tracking-[0.2em] text-gray-400">Cancellation & Arrival Policy</p>
      </div>
      <ul className="space-y-2 text-sm text-gray-400 leading-relaxed">
        <li>• <span className="text-gray-200">No refunds</span> for cancellations made less than <span className="text-gray-200">7 days</span> in advance.</li>
        <li>• Please <span className="text-gray-200">arrive 15 minutes before</span> your scheduled departure.</li>
        <li>• If you arrive late you may <span className="text-gray-200">forfeit your tour with no refund</span>.</li>
      </ul>
    </div>
  );
}
